import API from './core';

export default API;



// WEBPACK FOOTER //
// ./src/viewer/index.js